var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 5.99134C8.80898 5.43301 9.37565 4.51634 9.37565 3.66634C9.37565 1.78301 7.91732 0.333008 6.04232 0.333008H0.833984V11.9997H6.70065C8.44232 11.9997 9.79232 10.583 9.79232 8.84134C9.79232 7.57468 9.07565 6.49134 8.00065 5.99134ZM3.33398 2.41634H5.83398C6.52565 2.41634 7.08398 2.97467 7.08398 3.66634C7.08398 4.35801 6.52565 4.91634 5.83398 4.91634H3.33398V2.41634ZM6.25065 9.91634H3.33398V7.41634H6.25065C6.94232 7.41634 7.50065 7.97468 7.50065 8.66634C7.50065 9.35801 6.94232 9.91634 6.25065 9.91634Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.339258f222809997732c2eecabd353cc.svg";
export { ForwardRef as ReactComponent };